/*
 * @Author: 肖玲
 * @Date: 2023-03-01 13:44:20
 * @LastEditTime: 2023-06-01 10:46:04
 * @LastEditors: 肖玲
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\butterfly-flow-system\flow-direction-data-query\modules\rawDataRouter.js
 * 原始数据路由
 */
const rawDataRouter = [
  // 原始数据汇总
  //flow_attr  1日报 3月报
  {
    path: '/flowSystem/raw-data-summary/:flow_attr',
    name: 'flowSystemRawDataSummary',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemConfig3" */
      //   '@/views/flowSystem/RawDataSummary.vue'
      // ),  待删除文件
      import(
        /*webpackChunkName:"flowSystemConfig3" */
        '@/views/butterfly-flow-system/flow-direction-data-query/raw-data/summary/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '原始数据', //二级菜单
      title: '原始数据统计',
    },
  },
  // 原始数据汇总》报表设置
  //flow_attr  1日报 3月报
  {
    path: '/flowSystem/report-settings/:flow_attr',
    name: 'flowSystemReportSettings',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemConfig3" */
      //   '@/views/flowSystem/ReportSettings.vue'
      // ),  待删除文件
      import(
        /*webpackChunkName:"flowSystemConfig3" */
        '@/views/butterfly-flow-system/flow-direction-data-query/raw-data/summary/ReportSetting.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '原始数据', //二级菜单
      title: '报表设置',
      breadcrumb: [
        {
          title: '原始数据统计',
          name: 'flowSystemRawDataSummary',
        },
      ],
    },
  },
  // 原始数据查询 差异对比
  {
    path: '/flowSystem/original-data-difference',
    name: 'flowSystemDiffComparison',
    component: () =>
      // import('@/views/flowSystem/diffComparison/DiffComparison.vue'),  待删除文件
      import(
        '@/views/butterfly-flow-system/flow-direction-data-query/raw-data/Comparison.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '原始数据', //二级菜单
      title: '原始数据差异对比',
      // breadcrumb: [
      //   {
      //     title: '原始数据差异查询',
      //     name: 'flowSystemDiffComparison',
      //   },
      // ],
    },
  },
  // 原始数据查询 flow_attr   1日报 3月报
  {
    //TODO 2021.4.29发
    path: '/flowSystem/original-data/:flow_attr',
    // path: '/flowSystem/original-data',
    name: 'flowSystemOriginalData',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemConfig3" */
      //   '@/views/flowSystem/OriginalData.vue'
      // ),待删除文件
      import(
        /*webpackChunkName:"flowSystemConfig3" */
        '@/views/butterfly-flow-system/flow-direction-data-query/raw-data/query/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '原始数据', //二级菜单
      title: '原始数据查询',
    },
  },
  // 原始数据详情 flow_attr   1日报 3月报
  {
    //TODO 2021.4.29发
    path: '/flowSystem/original-data-detail/:flow_upload_id/:data_type/:temp_filter_value/:flow_attr',
    // path:'/flowSystem/original-data-detail/:flow_upload_id/:data_type/:temp_filter_value',
    name: 'flowSystemOriginalDataDetail',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemConfig4" */
      //   '@/views/flowSystem/OriginalDataDetail.vue'
      // ),待删除文件
      import(
        /*webpackChunkName:"flowSystemConfig4" */
        '@/views/butterfly-flow-system/flow-direction-data-query/raw-data/query/Deatil.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '原始数据', //二级菜单
      title: '原始数据详情',
      breadcrumb: [
        {
          title: '原始数据查询',
          name: 'flowSystemOriginalData',
        },
      ],
    },
  },
  // 原始数据查询(日)
  {
    path: '/flowSystem/original-data-day',
    name: 'flowSystemOriginalDataDay',
    component: () =>
      import(
        /*webpackChunkName:"flowSystemConfig3" */
        '@/views/flowSystem/rawData/OriginalDataDay.vue'
      ),
    meta: {
      title: '原始数据查询(日)',
    },
  },
  // 原始数据详情(日)
  {
    path: '/flowSystem/original-data-day-detail/:flow_upload_id/:data_type',
    name: 'flowSystemOriginalDataDayDetail',
    component: () =>
      import(
        /*webpackChunkName:"flowSystemConfig4" */
        '@/views/flowSystem/rawData/OriginalDataDayDetail.vue'
      ),
    meta: {
      title: '原始数据详情',
      breadcrumb: [
        {
          title: '原始数据查询(日)',
          name: 'flowSystemOriginalDataDay',
        },
      ],
    },
  },
  // 合并查询明细(日)
  {
    path: '/flowSystem/original-data-day-detail-merge/:data_type/:start_date/:end_date/:province_id/:data_source/:search_text',
    name: 'flowSystemOriginalDataDayDetailMerge',
    component: () =>
      import(
        /*webpackChunkName:"flowSystemConfig4" */
        '@/views/flowSystem/rawData/OriginalDataDayDetailMerge.vue'
      ),
    meta: {
      title: '合并查询明细',
      breadcrumb: [
        {
          title: '原始数据查询(日)',
          name: 'flowSystemOriginalDataDay',
        },
      ],
    },
  },
  // 原始数据查询(日)(对接日志)
  {
    path: '/flowSystem/original-data-log/:data_type/:start_date/:end_date',
    name: 'flowSystemOriginalDataLog',
    component: () =>
      import(
        /*webpackChunkName:"flowSystemConfig3" */
        '@/views/flowSystem/rawData/OriginalDataLog.vue'
      ),
    meta: {
      title: '对接日志',
      breadcrumb: [
        {
          title: '原始数据查询(日)',
          name: 'flowSystemOriginalDataDay',
        },
      ],
    },
  },
  // 原始数据查询(日)(对接日志)(对接日志明细)
  {
    path: '/flowSystem/original-data-log-detail/:flow_upload_id/:data_attr/:data_type/:start_date/:end_date',
    name: 'flowSystemOriginalDataLogDetail',
    component: () =>
      import(
        /*webpackChunkName:"flowSystemConfig3" */
        '@/views/flowSystem/rawData/OriginalDataLogDetail.vue'
      ),
    meta: {
      title: '对接日志明细',
      breadcrumb: [
        {
          title: '原始数据查询(日)',
          name: 'flowSystemOriginalDataDay',
        },
        {
          title: '对接日志',
          name: 'flowSystemOriginalDataLog',
        },
      ],
    },
  },

  // 原始数据查询(月)
  {
    path: '/flowSystem/original-data-month',
    name: 'flowSystemOriginalDataMonth',
    component: () =>
      import(
        /*webpackChunkName:"flowSystemConfig3" */
        '@/views/flowSystem/rawData/OriginalDataMonth.vue'
      ),
    meta: {
      title: '原始数据查询(月)',
    },
  },
  // 原始数据详情(月)
  {
    path: '/flowSystem/original-data-month-detail/:flow_upload_id/:data_type',
    name: 'flowSystemOriginalDataMonthDetail',
    component: () =>
      import(
        /*webpackChunkName:"flowSystemConfig4" */
        '@/views/flowSystem/rawData/OriginalDataMonthDetail.vue'
      ),
    meta: {
      title: '原始数据详情',
      breadcrumb: [
        {
          title: '原始数据查询(月)',
          name: 'flowSystemOriginalDataMonth',
        },
      ],
    },
  },
  // 合并查询明细(月)
  {
    path: '/flowSystem/original-data-month-detail-merge/:data_type/:province_id/:data_source/:search_text/:month_date',
    name: 'flowSystemOriginalDataMonthDetailMerge',
    component: () =>
      import(
        /*webpackChunkName:"flowSystemConfig4" */
        '@/views/flowSystem/rawData/OriginalDataMonthDetailMerge.vue'
      ),
    meta: {
      title: '合并查询明细',
      breadcrumb: [
        {
          title: '原始数据查询(月)',
          name: 'flowSystemOriginalDataMonth',
        },
      ],
    },
  },
  // 原始商业库存查询
  {
    path: '/flowSystem/original-data-inventory',
    name: 'flowSystemOriginalDataInventory',
    component: () =>
      import(
        /*webpackChunkName:"flowSystemConfig4" */
        '@/views/flowSystem/rawData/OriginalDataInventory.vue'
      ),
    meta: {
      title: '原始商业库存查询',
    },
  },
  {
    path: '/flowSystem/init-data-page',
    // path:'/flowSystem/original-data-detail/:flow_upload_id/:data_type/:temp_filter_value',
    name: 'flowSystemInitDataPage',
    component: () =>
      import(
        /*webpackChunkName:"flowSystemConfig4" */
        '@/views/butterfly-flow-system/flow-direction-data-query/raw-data/flow-init-data/Page.vue'
      ),
    meta: {
      SecondaryMenu: '原始数据', //二级菜单
      title: '初始流向差异',
    },
  },
  {
    path: '/flowSystem/init-data-diff-set-page',
    name: 'flowSystemInitDataDiffSetPage',
    component: () =>
      import(
        /*webpackChunkName:"flowSystemConfig4" */
        '@/views/butterfly-flow-system/flow-direction-data-query/raw-data/flow-init-data/diffSetPage.vue'
      ),
    meta: {
      SecondaryMenu: '原始数据', //二级菜单
      title: '取数记录',
      breadcrumb: [
        {
          title: '初始流向差异',
          name: 'flowSystemInitDataPage',
        },
      ],
    },
  },
]
export default rawDataRouter
